export default [
  {
    path: '/insurance/sales',
    name: 'SalesInsurance',
    component: () => import('@/views/Insurance/Sales.vue'),
    meta: {
      pageTitle: 'Sigorta',
      breadcrumb: [
        {
          text: 'Sıfır Satış',
          active: true,
        },
      ],
      resource: 'RP_INSURANCE',
      action: 'read',
    },
  },
  {
    path: '/insurance/sales-cumulatives',
    name: 'SalesInsuranceCumulatives',
    component: () => import('@/views/Insurance/SalesCumulatives.vue'),
    meta: {
      pageTitle: 'Sigorta',
      breadcrumb: [
        {
          text: 'Sıfır Satış Kümülatif',
          active: true,
        },
      ],
      resource: 'RP_INSURANCE',
      action: 'read',
    },
  },
  {
    path: '/insurance/second-hand-sales',
    name: 'SecondHandInsurance',
    component: () => import('@/views/Insurance/SecondHandSales.vue'),
    meta: {
      pageTitle: 'Sigorta',
      breadcrumb: [
        {
          text: 'İkinci El Satış Poliçe Raporu',
          active: true,
        },
      ],
      resource: 'RP_INSURANCE',
      action: 'read',
    },
  },
  {
    path: '/insurance/second-hand-sales-cumulatives',
    name: 'SecondHandInsuranceCumulatives',
    component: () => import('@/views/Insurance/SecondHandSalesCumulatives.vue'),
    meta: {
      pageTitle: 'Sigorta',
      breadcrumb: [
        {
          text: '2. El Satış Kümülatif',
          active: true,
        },
      ],
      resource: 'RP_INSURANCE',
      action: 'read',
    },
  },
  {
    path: '/insurance/renewals',
    name: 'RenewalInsurance',
    component: () => import('@/views/Insurance/Renewals.vue'),
    meta: {
      pageTitle: 'Sigorta',
      breadcrumb: [
        {
          text: 'Yenileme',
          active: true,
        },
      ],
      resource: 'RP_INSURANCE',
      action: 'read',
    },
  },
  {
    path: '/insurance/branches-insurance',
    name: 'BranchesInsurance',
    component: () => import('@/views/Insurance/BranchesInsurance.vue'),
    meta: {
      pageTitle: 'Sigorta',
      breadcrumb: [
        {
          text: 'Branş Bazlı Ciro',
          active: true,
        },
      ],
      resource: 'RP_INSURANCE',
      action: 'read',
    },
  },
  {
    path: '/insurance/production-insurance',
    name: 'ProductionInsurance',
    component: () => import('@/views/Insurance/ProductionInsurance.vue'),
    meta: {
      pageTitle: 'Sigorta',
      breadcrumb: [
        {
          text: 'Üretim ve Komisyon',
          active: true,
        },
      ],
      resource: 'RP_INSURANCE',
      action: 'read',
    },
  },
]
